import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingHero = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-20 lg:py-28 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
          <div className="max-w-3xl">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
              <span className="text-sm font-medium text-primary">
                {language === 'fr' ? 'FCO · OPCO · FIF-PL · Sur-mesure' : 'CLE · OPCO · Custom Programs'}
              </span>
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
              {language === 'fr' ? 'Formation IA Avocat : maîtrisez l\'IA juridique' : 'Legal AI Training for Lawyers'}
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              {language === 'fr'
                ? 'Formation continue obligatoire, programmes ad hoc et solutions IA sur-mesure pour avocats, juristes et notaires. Éligible OPCO et FIF-PL.'
                : 'Mandatory CLE, custom programs and bespoke AI solutions for lawyers, counsel and notaries. OPCO and FIF-PL eligible.'}
            </p>
          </div>
          <div className="mt-12 lg:mt-0">
            <img 
              src="/images/seo-training-formation-ia-avocat.webp"
              alt={language === 'fr'
                ? "Formation IA avocat : séminaire intelligence artificielle juridique, formation continue obligatoire FCO CNB, OPCO FIF-PL CPF Mon compte formation, ChatGPT Claude Gemini droit"
                : "Legal AI training for lawyers: continuing legal education CLE, ChatGPT Claude Gemini for law, OPCO FIF-PL eligible, bar council certified"}
              title={language === 'fr'
                ? "Gaius - Formation IA avocat juriste : programmes ChatGPT Claude Gemini pour cabinets d'avocats et directions juridiques | FCO OPCO FIF-PL CPF"
                : "Gaius - Legal AI training: ChatGPT Claude Gemini programs for law firms and legal departments | CLE OPCO eligible"}
              loading="lazy"
              decoding="async"
              width={1200}
              height={630}
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
